export default __webpack_public_path__ + "static/media/kasambahay.b03599f4.webp";